import CustomisableWidgetEditor from './base/customisable-widget-editor';
import $ from 'jquery';
import { schedule } from '@ember/runloop';
import Em from 'ember';
export default CustomisableWidgetEditor.extend({
  attributeBindings: [],
  autoFocusSelector: 'textarea',
  keysToTriggerClose: [9, 13, 27],
  placeholder: 'Enter your company’s physical address',
  address: Em.computed('emailTemplateData.[]', 'emailTemplateData.@each.value', function () {
    return this.findEmailTemplateDatum('address');
  }),
  init() {
    this._super(...arguments);
    this.set('classNames', ['ember-view', 'customisable-widget-editor-text']);
    this.set('addressBefore', this.get('address.value'));
  },
  didInsertElement() {
    this._super(...arguments);
    this.autoFocus();
  },
  autoFocus() {
    $('textarea', this.element).focus();
  },
  textDidChange: Em.observer({
    dependentKeys: ['address.value'],
    fn() {
      schedule('afterRender', this, function () {
        if ($(this.element)) {
          $('textarea', this.element).height($('p', this.element).height());
        }
      });
    },
    sync: true
  }),
  actions: {
    dismiss() {
      let changes = [];
      let addressNow = this.get('address.value');
      if (this.get('addressBefore') !== addressNow) {
        changes.push({
          identifier: 'address',
          value: addressNow
        });
      }
      this.closeEditor(changes);
    }
  }
});